module.exports = __webpack_public_path__ + "83fc28070f0cf46e6fd83564a6cb83d9.svg";